import { isNil, reject } from 'ramda'

/** @internal */
export const shallowRemoveEmptyParam = reject(isNil)
